// extracted by mini-css-extract-plugin
export default {"container":"GameFilter_container__xqG7l"};